function personalInfo(state = {}, action) {
  switch (action.type) {
    case 'SET_PROFILE_DATA':
      return { ...state, profile: action.profile };

    case 'RESET_PROFILE_DATA':
      return { ...state, profile: {} };

    case 'GET_PROFILE_DATA_SUCCESS':
      return { ...state, success: action.success };

    case 'GET_PROFILE_DATA_FAIL':
      return { ...state, success: action.success };

    case 'EDIT_PROFILE_DATA_SUCCESS':
      return { ...state, editProfDatasuccess: action.editProfDatasuccess };

    case 'EDIT_PROFILE_DATA_FAIL':
      return { ...state, editProfDatasuccess: action.editProfDatasuccess };

    case 'OTP_SENT_SUCCESS':
      return {
        ...state,
        otpSentSuccess: action.otpSentSuccess,
        otpResponseObj: action.otpResponseObj
      };

    case 'OTP_VERIFY':
      return { ...state, otpVerifyResponseObj: action.otpVerifyResponseObj };

    case 'EMAIL_OTP_VERIFY':
      return { ...state, emailOtpVerifyResponseObj: action.emailOtpVerifyResponseObj };

    case 'OTP_SENT_FAIL':
      return { ...state, otpSentSuccess: action.otpSentSuccess };

    case 'CLEAR_OTP_DATA':
      return { ...state, otpVerifyResponseObj: [] };

    case 'UPDATE_EMAIL':
      return { ...state, emailUpdate: action.emailUpdate };

    case 'UPDATE_JIOPRIME_PROFILE_INFO':
      let updatedProfile = { ...state.profile };
      updatedProfile.isRegisteredToJioPrime = action.updatedConfig.jioPrimeRegistered;
      updatedProfile.isLinkedToAjio = action.updatedConfig.jioPrimeLinked;
      return { ...state, profile: updatedProfile };

    default:
      return state;
  }
}

export default personalInfo;
